if (typeof complementaryProductsComponent === 'undefined')
{   
    class ComplementaryProductsComponent extends HTMLElement {
        constructor() {
            super();
            this.handleResponsiveColumnCarousel = null;
        }

        connectedCallback() {
            const url = this.dataset.url;

            this.buildProducts(url);    
        }

        buildProducts(url) {
            const fetchProducts = async (url) => {
                const res = await fetch(url);
                let text = await res.text();
                    
                const html = document.createElement('div');
                text = text.replaceAll('variant-selects', 'div').replaceAll('variant-radios', 'div').replaceAll('product-tab', 'div').replaceAll('compare-color', 'div').replaceAll('breadcrumb-component', 'div');
                html.innerHTML = text;
                
                const recommendations = html.querySelector('[data-complementary-product]');
                if (recommendations && recommendations.innerHTML.trim().length) {
                    this.innerHTML = recommendations.innerHTML;
    
                    if (window.sharedFunctions.checkNeedToConvertCurrency()) {
                        Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                    }
                }
                    
                const productCarousel = this.querySelector('.products-carousel');
                this.initializeSlider(productCarousel);
            }
    
            fetchProducts(url);
        }
        
        initializeSlider(productCarousel = null) {
            if (productCarousel) {
                const useDotNavigation = productCarousel.classList.contains('column-4');
                const itemArrows = useDotNavigation ? false : productCarousel.dataset.itemArrows === 'true';
                const itemDots = useDotNavigation ? true : productCarousel.dataset.itemDots === 'true';
                const itemRows = parseInt(productCarousel.dataset.itemRows);
                const itemToShow = parseInt(productCarousel.dataset.itemToShow);
                const complementaryStyle = this.classList.contains('style-1') ? true : false;
                const columnFourCarousel = complementaryStyle && productCarousel.classList.contains('column-4');

                if (columnFourCarousel) {
                    this.updateResponsiveCarouselState(productCarousel);
                }

                $(productCarousel).on('init', () => {
                    this.calculateCard06Padding();
                });

                if(!productCarousel.classList.contains('slick-slider')) {
                    $(productCarousel).slick({
                        mobileFirst: columnFourCarousel,
                        dots: itemDots,
                        arrows: itemArrows,
                        slidesToShow: complementaryStyle ? (columnFourCarousel ? this.getResponsiveColumnCount() : itemToShow) : 1,
                        rows: !complementaryStyle ? itemRows : 1,
                        slidesToScroll: complementaryStyle ? (columnFourCarousel ? this.getResponsiveColumnCount() : 1) : 1,
                        slidesPerRow: 1,
                        infinite: true,
                        rtl: window.rtl_slick,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        responsive: [
                            {
                                breakpoint: 321,
                                settings: {
                                    slidesToShow: columnFourCarousel ? 1 : 1,
                                    slidesToScroll: columnFourCarousel ? 1 : 1
                                }
                            },
                            {
                                breakpoint: 600,
                                settings: {
                                    slidesToShow: columnFourCarousel ? 2 : 1,
                                    slidesToScroll: columnFourCarousel ? 2 : 1
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: columnFourCarousel ? 2 : (complementaryStyle ? 2 : 1),
                                    slidesToScroll: columnFourCarousel ? 2 : 1
                                }
                            },
                            {
                                breakpoint: 900,
                                settings: {
                                    slidesToShow: columnFourCarousel ? 3 : (complementaryStyle ? 2 : 1),
                                    slidesToScroll: columnFourCarousel ? 3 : 1
                                }
                            },
                            {
                                breakpoint: 1250,
                                settings: {
                                    slidesToShow: columnFourCarousel ? itemToShow : (complementaryStyle ? itemToShow : 1),
                                    slidesToScroll: columnFourCarousel ? itemToShow : 1
                                }
                            }
                        ]
                    });
                }

                if (columnFourCarousel) {
                    this.bindResponsiveColumnCarousel(productCarousel);
                }
            }
        }

        getResponsiveColumnCount() {
            if (window.innerWidth < 600) return 1;
            if (window.innerWidth < 900) return 2;
            if (window.innerWidth < 1250) return 3;
            return 4;
        }

        updateResponsiveCarouselState(productCarousel) {
            const columnCount = this.getResponsiveColumnCount();

            productCarousel.classList.remove('column-1', 'column-2', 'column-3', 'column-4');
            productCarousel.classList.add(`column-${columnCount}`);
            productCarousel.dataset.itemToShow = String(columnCount);
        }

        bindResponsiveColumnCarousel(productCarousel) {
            if (this.handleResponsiveColumnCarousel) {
                window.removeEventListener('resize', this.handleResponsiveColumnCarousel);
            }

            this.handleResponsiveColumnCarousel = () => {
                this.updateResponsiveCarouselState(productCarousel);

                if ($(productCarousel).hasClass('slick-initialized')) {
                    const columnCount = this.getResponsiveColumnCount();
                    $(productCarousel).slick('slickSetOption', {
                        slidesToShow: columnCount,
                        slidesToScroll: columnCount
                    }, true);
                }
            };

            window.addEventListener('resize', this.handleResponsiveColumnCarousel);
        }
        
        calculateCard06Padding() {
            if (!document.body.classList.contains('product-card-layout-06')) return;

            const selectOptionsHeight = this.querySelector('.product .card-action').scrollHeight;
            this.querySelector('.slick-list').style.paddingBottom = selectOptionsHeight + 'px';
        }
    }
    
    window.addEventListener('load', () => {
        customElements.define('complementary-products', ComplementaryProductsComponent);
    })

    var complementaryProductsComponent = ComplementaryProductsComponent;
}
